import { Component, Input } from '@angular/core';
import { parseUtmTag, UtmTagRow } from '../../../utils/utm-tag-parser';

@Component({
	selector: 'utm-tags-table',
	templateUrl: './utm-tags-table.component.html',
	styleUrls: ['./utm-tags-table.component.scss']
})
export class UtmTagsTableComponent {
	@Input() utmTag: string;

	get rows(): UtmTagRow[] {
		return parseUtmTag(this.utmTag);
	}
}
